<button
  class="buy-now-button"
  [attr.type]="type"
  [disabled]="disabled"
  (click)="onClick($event)"
>
  <span class="buy-now-button__icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  </span>
  <span class="buy-now-button__label">{{ label }}</span>
</button>
